import React, { createContext, useContext, useEffect, useState } from "react";

const OfflineContext = createContext();

export const OfflineProvider = ({ children }) => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    async function checkConnectivity() {
      // Try a very small, fast request to confirm real internet access
      try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 2500);

        // Use a reliable small asset — Supabase ping or Google favicon
        await fetch("https://www.google.com/favicon.ico", {
          method: "HEAD",
          mode: "no-cors",
          signal: controller.signal,
        });

        clearTimeout(timeout);
        setIsOffline(false);
      } catch {
        setIsOffline(true);
      }
    }

    // Listen for connection changes
    const updateStatus = () => checkConnectivity();

    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);

    // Initial check + interval
    checkConnectivity();
    const interval = setInterval(checkConnectivity, 10000); // recheck every 10s

    return () => {
      clearInterval(interval);
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, []);

  return <OfflineContext.Provider value={{ isOffline }}>{children}</OfflineContext.Provider>;
};

export const useOffline = () => useContext(OfflineContext);
